import type { PlayerTalent } from "@golazo/shared";
import type { Attributes } from "./model.js";

/**
 * De la ficha al campo.
 *
 * Un atributo de 70 es el jugador de referencia (multiplicador 1). De 40 a 100
 * el efecto va de −4 % a +4 %: ocho puntos de recorrido en total, que es lo que
 * se decidio para la carrera. Se nota —el veterano llega antes al balon que el
 * chaval— pero no convierte el juego en otro, y NUNCA sale de la carrera: el
 * online no conoce nada de esto.
 */
export const TALENT_SPAN = 0.04;

export function multiplierFor(value: number): number {
  const t = Math.max(-1, Math.min(1, (value - 70) / 30));
  return 1 + t * TALENT_SPAN;
}

export function talentFromAttributes(a: Attributes): PlayerTalent {
  return {
    pace: multiplierFor(a.pace),
    shooting: multiplierFor(a.shooting),
    passing: multiplierFor(a.passing),
    stamina: multiplierFor(a.stamina),
  };
}

/**
 * La plantilla de un club juega a la altura de su fuerza. Un club de 35 corre
 * un poco menos que uno de 85; entre los dos, algo mas de un 6 %.
 */
export function talentFromClubRating(rating: number): PlayerTalent {
  const m = multiplierFor(rating);
  return { pace: m, shooting: m, passing: m, stamina: m };
}
